module.exports = __webpack_public_path__ + "images/Rss.fb17d1c8e5c3b3e0b3d1d6ed3227acdc.svg";